import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { ConfirmDialogComponent } from "./confirm-dialog.component";
import { ConfirmService } from "./confirm.service";

@NgModule({
  imports: [CommonModule, MatDialogModule],
  declarations: [ConfirmDialogComponent],
  providers: [ConfirmService]
})
export class UiConfirmModule {}
